<ws10-headline-brix *ngIf="headlineConfig" [headlineConfig]="headlineConfig"></ws10-headline-brix>
